import { parsePositiveInteger } from 'src/shared/urlValidators';
import React from 'react';
import Helmet from 'react-helmet';
import { Redirect, useParams } from 'react-router-dom';
import { useJoinUrl } from 'src/client/components/buttons/JoinButton';
import { UNAUTHORIZED_ROUTE } from 'src/client/constants/joinCampaigns';
import { useSelector } from 'src/client/redux/modules/helpers/useSelector';
import { MainPageTitle } from 'src/client/components/layouts/MainPageTitle';
import NotFound from 'src/client/containers/NotFound/NotFound';
import { canViewSfwImages, getSfwTotalPages } from 'src/shared/sfwImages';
import { SfwImagesPage } from './SfwImagesPage';
import { getSfwPagePath } from './paths';

export const SfwImagesRoute = () => {
  const { loaded, user } = useSelector((state) => state.auth);
  const config = useSelector((state) => state.app.config);
  const { page: rawPage } = useParams<{ page?: string }>();
  const [joinUrl] = useJoinUrl({ campaign: UNAUTHORIZED_ROUTE });

  if (!loaded) return null;
  const page = rawPage === undefined ? 1 : parsePositiveInteger(rawPage);
  if (page === null || page > getSfwTotalPages(config)) return <NotFound />;
  if (!user) return <Redirect to={joinUrl} />;
  if (!canViewSfwImages(user)) return <NotFound />;
  if (rawPage === '1') return <Redirect to={getSfwPagePath(1)} />;

  return (
    <main className="content container">
      <Helmet>
        <title>SFW Images</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <MainPageTitle>SFW Images</MainPageTitle>
      <SfwImagesPage page={page} totalPages={getSfwTotalPages(config)} />
    </main>
  );
};
